export const CalendarSettingsFormsFixture = {
  empty: 'empty',
  manyTaskTypes: 'many-task-types',
  mock: 'mock',
}

export const CALENDAR_SETTINGS_FORMS_FIXTURE_IDS = [
  CalendarSettingsFormsFixture.mock,
  CalendarSettingsFormsFixture.manyTaskTypes,
  CalendarSettingsFormsFixture.empty,
]

export const CALENDAR_SETTINGS_FORMS_FIXTURES = [
  {
    id: CalendarSettingsFormsFixture.mock,
    qaName: 'calendarSettingsFormsMock',
    text: 'On the mock',
  },
  {
    id: CalendarSettingsFormsFixture.manyTaskTypes,
    qaName: 'calendarSettingsFormsManyTaskTypes',
    text: 'More than 25 task types',
  },
  {
    id: CalendarSettingsFormsFixture.empty,
    qaName: 'calendarSettingsFormsEmpty',
    text: 'No task types, no time zone',
  },
]
